import React, { useState } from "react";
import { ProductExpertOpinionModel } from "@admin/domain/products/models/edit/ProductExpertOpinionModel";
import MultiLanguages from "@admin/components/MultiLanguage";
import ExpertOpinionTexts from "./ExpertOpinionTexts";
import ExpertOpinionImage from "@admin/pages/ProductEditor/ProductExpertOpinion/ExpertOpinionImage";
import ExpertOpinionVideo from "@admin/pages/ProductEditor/ProductExpertOpinion/ExpertOpinionVideo";

export default function ProductExpertOpinion({
    productExpertOpinion,
}: {
    productExpertOpinion?: ProductExpertOpinionModel;
}) {
    const [isPublic, setIsPublic] = useState(productExpertOpinion?.is_public || false);

    return (
        <div className="rounded border p-10 mb-5">
            <h4 className="mb-5">Мнение эксперта</h4>
            <div className="mb-5">
                <div className="form-check form-check-custom form-check-solid">
                    <input type="hidden" name="expert[is_public]" value="0" />
                    <input
                        className="form-check-input"
                        type="checkbox"
                        checked={isPublic}
                        id="expert_is_public"
                        name="expert[is_public]"
                        value="1"
                        onChange={(event) => setIsPublic(event.target.checked)}
                    />
                    <label className="form-check-label form-label" htmlFor="expert_is_public">
                        Показывать мнение эксперта
                    </label>
                </div>
            </div>
            {isPublic && (
                <>
                    <ExpertOpinionImage image={productExpertOpinion?.file || null} />
                    <ExpertOpinionVideo initVideo={productExpertOpinion?.video || null} />

                    <MultiLanguages
                        languageElement={(language) => (
                            <ExpertOpinionTexts language={language} texts={productExpertOpinion?.textsMap} />
                        )}
                    />
                </>
            )}
        </div>
    );
}
